<template>
    <b-card no-body>

        <b-card-body>
            <b-card bg-variant="light">
                <b-table responsive class="mt-2" stacked="sm" small outlined sticky-header show-empty :busy="this.busy"
                    :items="this.records" :fields="tableFields">
                    <template #empty>
                        <p>Nenhum resultado encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página
                            {{ page }} de {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"

export default {
    components: {
    },

    props: {
        id: Number
    },
    mixins: [FormResourceMixin, ListResourceMixin],

    data() {
        return {
            busy: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],

        };
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/historicoalteracao`);
    },
    async mounted() {
        this.load();
    },

    watch: {
        page() {
            this.load();
        },

    },

    computed: {

        tableFields() {
            return [
                {
                    key: "data",
                    label: "Data",
                    formatter: (data) => moment(String(data)).format("DD/MM/YYYY"),
                },
                { key: "operacao", label: "Operação" },
                { key: "responsavel", label: "Responsável" },

            ];
        },
    },

    methods: {
        async load() {

            this.params = {};
            this.params.id = this.id;
            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });
        },


    },
};
</script>